import { useLocalization } from "@fluent/react";
import { Button, ContentCard, ResponsiveFlex, Row } from "@narmi/design_system";
import type MemberFriend from "byzantine/src/MemberFriend";

interface ViewMemberProps {
  memberFriend: MemberFriend;
  onDelete: () => void;
}

const DetailRow = ({ label, value }: { label: string; value: string }) => (
  <Row alignItems="top" gapSize="xxs">
    <Row.Item>
      <div className="fontSize--s fontColor--secondary">{label}</div>
    </Row.Item>
    <Row.Item>
      <div style={{ overflowWrap: "anywhere" }}>{value}</div>
    </Row.Item>
  </Row>
);

const ViewMember = ({ memberFriend, onDelete }: ViewMemberProps) => {
  const { l10n } = useLocalization();

  return (
    <ResponsiveFlex gapSize="xl">
      <Row alignItems="top">
        <Row.Item>
          <h2 style={{ overflowWrap: "anywhere" }}>{memberFriend.name}</h2>
          <div className="fontSize--s fontColor--secondary">
            {l10n.getString("member-drawer-subtitle")}
          </div>
        </Row.Item>
        <Row.Item shrink>
          <Button
            kind="plain"
            startIcon="trash-2"
            onClick={onDelete}
            label={l10n.getString("button-menu-delete")}
          />
        </Row.Item>
      </Row>
      <ContentCard kind="bordered" paddingSize="l">
        <ResponsiveFlex gapSize="s">
          <DetailRow
            label={l10n.getString("label-name")}
            value={memberFriend.name}
          />
          {/* TODO: the API only returns the masked account number. We'll figure
              out later whether we can get the full number (and add the copy
              icon from the design) */}
          <DetailRow
            label={l10n.getString("member-account-number-label")}
            value={memberFriend.displayMaskedAccountNumber()}
          />
          {memberFriend.relationship ? (
            <DetailRow
              label={l10n.getString("member-drawer-relationship-label")}
              value={memberFriend.relationship}
            />
          ) : null}
        </ResponsiveFlex>
      </ContentCard>
    </ResponsiveFlex>
  );
};

export default ViewMember;
